import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import generateClassesFromMap from '@insight/toolkit-utils/lib/generators/generateClassesFromMap';

import { BADGE_COLORS, BADGE_CLASS_MAP } from './classes';

const Badge = (props) => {
  const { bold, children, className, color } = props;

  const derivedClasses = generateClassesFromMap({ color }, BADGE_CLASS_MAP);

  const classes = cn(
    'c-badge',
    derivedClasses,
    {
      ' c-badge--bold': bold,
    },
    className
  );

  return <span className={classes}>{children}</span>
};

export default Badge;

Badge.propTypes = {
  bold: PropTypes.bool,
  color: PropTypes.oneOf(BADGE_COLORS),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Badge.defaultProps = {
  bold: false,
  className: '',
  color: null,
};
